import { render, staticRenderFns } from "./Zone.vue?vue&type=template&id=3fc54268&"
import script from "./Zone.vue?vue&type=script&lang=ts&"
export * from "./Zone.vue?vue&type=script&lang=ts&"
import style0 from "./Zone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports